import React, { useEffect, useState } from "react";
import './styles.css'
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { displayErrorToast, displaySuccessToast, isEmpty, isNull, isValidEmail } from "../../../utils/Utils";
import {
    subscriptionListRequest, updateTransactionStatusRequest, updateTransactionStatusRequestStatus, newTransactionRequest,
    newTransactionRequestStatus
} from '../../../redux/subscription/subscription.action'
import { renewTrailSubscriptionRequest, renewTrailSubscriptionRequestStatus } from '../../../redux/user/user.action'
import { useDispatch, useSelector } from 'react-redux'
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import Modal from 'react-bootstrap/Modal';
import { config } from "../../../config";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const SubscriptionRenewScreen = props => {
    const [isLoading, setLoading] = useState(false)
    let navigate = useNavigate();
    const { user, renewTrailSubscriptionSuccess, renewTrailSubscriptionError, renewTrailSubscriptionReqStatus } = useSelector(state => state.user)
    const { subscriptionListSuccess, subscriptionListError,
        newTransactionSuccess, newTransactionError, newTransactionReqStatus,
        updateTransactionStatusSuccess, updateTransactionStatusError, updateTransactionStatusReqStatus
    } = useSelector(state => state.subscription)
    const dispatch = useDispatch()
    const [showPaymentModal, setShowPaymentModal] = useState(false)
    const [showUpdateTransactionModal, setShowUpdateTransactionModal] = useState(false)

    useEffect(() => {
        setLoading(true)
        const subscriptionPayload = {
            isActive: true,
            productCode: APP_CONSTANTS.PRODUCT_NAME
        }
        dispatch(subscriptionListRequest(subscriptionPayload))
    }, [])

    useEffect(() => {
        if (renewTrailSubscriptionReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(renewTrailSubscriptionSuccess.data?.message)
            navigateToNextScreen()
        } else if (renewTrailSubscriptionReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(renewTrailSubscriptionError.message)
        }
        if (renewTrailSubscriptionReqStatus?.length) {
            dispatch(renewTrailSubscriptionRequestStatus(''))
        }
    }, [renewTrailSubscriptionSuccess, renewTrailSubscriptionError, renewTrailSubscriptionReqStatus])

    useEffect(() => {
        if (updateTransactionStatusReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            navigateToNextScreen()
        } else if (updateTransactionStatusReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            setShowUpdateTransactionModal(true)
        }
        if (updateTransactionStatusReqStatus?.length) {
            dispatch(updateTransactionStatusRequestStatus(''))
        }
    }, [updateTransactionStatusSuccess, updateTransactionStatusError, updateTransactionStatusReqStatus])

    useEffect(() => {
        if (newTransactionReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowPaymentModal(true)
        } else if (newTransactionReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(newTransactionError.message)
        }
        if (newTransactionReqStatus?.length) {
            dispatch(newTransactionRequestStatus(''))
        }
    }, [newTransactionSuccess, newTransactionError, newTransactionReqStatus])

    useEffect(() => {
        if (!isNull(subscriptionListSuccess)) {
            setLoading(false)
        } else if (!isNull(subscriptionListError)) {
            setLoading(false)
        }
    }, [subscriptionListSuccess, subscriptionListError])

    const navigateToNextScreen = () => {
        if (user.data.userDetails.isProfileUpdated === false) {
            navigate(ROUTES.updateProfile, { replace: true })
        } else {
            navigate(ROUTES.menu, { replace: true })
        }
    }

    const CheckIcon = () => (
        <svg className="check-icon" viewBox="0 0 24 24">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
    );

    const getCardClassName = (item) => {
        if (item.isTrailSubscription) {
            return 'pricing-card free-card'
        } else if (!item.isMostFlexible) {
            return 'pricing-card highlighted'
        } else {
            return 'pricing-card'
        }
    }

    const handlePlanSelectClick = (item) => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId,
            subscriptionId: item.subscriptionId
        }
        if (item.isTrailSubscription === true) {
            dispatch(renewTrailSubscriptionRequest(data))
        } else {
            dispatch(newTransactionRequest(data))
        }
    }

    const handleUpdateTransactionStatus = () => {
        setLoading(true)
        const data = {
            transactionId: newTransactionSuccess.data.transaction.transactionId,
            userId: user.data.userDetails.userId,
            transactionStatus: APP_CONSTANTS.TRANSACTION_STATUS.PAID,
            updateEndDate: true
        }
        dispatch(updateTransactionStatusRequest(data))
        setShowUpdateTransactionModal(false)
    }

    const handlePaypalApprove = (data, actions) => {
        return actions.order.capture().then((details) => {
            console.log("Transaction completed:", details);
            console.log("Transaction completed:", details.status);
            if (details.status === 'COMPLETED') {
                setShowPaymentModal(false)
                handleUpdateTransactionStatus()
            }
        }).catch(err => {
            console.error("Transaction failed:", err);
            displayErrorToast('Transaction failed. Please try again.')
        });
    };

    const handlePaypalCancel = (data) => {
        displayErrorToast('You have cancelled the payment processing. Please process with payment to continue.')
    }

    const handlePaypalError = (error) => {
        displayErrorToast('Error occured. Please try again.')
    }

    return (
        <>
            {!isEmpty(subscriptionListSuccess) && <div className="pp-container">
                <h2 className="lp-title text-center">🔄 Keep Your Premium Access! 🔄</h2>
                <p className="lp-sub-title text-center">Don't lose your exclusive benefits! Renew your subscription to continue using togethra</p>
                <div className="cards-grid">
                    {subscriptionListSuccess.data.map(e => (<div className={getCardClassName(e)}>
                        <div className='price-content-container'>
                            {e.isTrailSubscription && <div className="card-badge">Start Free</div>}
                            {e.isMostFlexible && <div className="ribbon">Most Flexible</div>}
                            {!isEmpty(e.savingPercentage) && <div className="card-badge save">Save {e.savingPercentage}</div>}
                            <h3>{e.title}</h3>
                            <div className="price">{e.currencySymbol}{e.price}<small>{e.durationLabel}</small></div>
                            {!e.isTrailSubscription && <div className="billing-note">Billed as {e.currencySymbol}{e.finalPrice} every {e.duration} months</div>}
                            {!isEmpty(e.features) && <ul className="features-list">
                                {e.features.map(item => (<li><CheckIcon /> {item}</li>))}
                            </ul>}
                        </div>
                        <button className={e.isTrailSubscription ? "cta-button free" : 'cta-button'} onClick={() => { handlePlanSelectClick(e) }}>Select</button>
                    </div>))}
                </div>
                <div className="bonus-cta">
                    <p><strong>All plans include:</strong> Unlimited businesses & employees, granular access controls,
                        24/7 support, and all current/future features</p>
                </div>
            </div>}
            {!isEmpty(subscriptionListError) && <div className='content-error'>{subscriptionListError.message}</div>}
            <Modal
                onHide={() => { setShowPaymentModal(false) }}
                show={showPaymentModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static" keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Payment Processing
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="bca-success-modal-container">
                        <p className="bca-smc-label-three">To proceed, please select the option below to complete your payment.</p>
                        <PayPalScriptProvider options={{
                            intent: "capture",
                            clientId: config.PP_ID
                        }}>
                            <PayPalButtons
                                createOrder={(data, actions) => {
                                    return actions.order.create({
                                        intent: "CAPTURE",
                                        purchase_units: [{
                                            amount: {
                                                value: isEmpty(newTransactionSuccess) ? 0 : newTransactionSuccess.data.transaction.amount,
                                                "currency_code": (!isEmpty(user) && !isEmpty(newTransactionSuccess.data.transaction)) ? newTransactionSuccess.data.transaction.currencyCode : 'USD'
                                            }
                                        }],
                                        application_context: {
                                            shipping_preference: "NO_SHIPPING",
                                            user_action: "PAY_NOW"
                                        },
                                        payer: {
                                            "name": {
                                                "given_name": !isEmpty(user) ? user.data.userDetails.firstName : "Firstname",
                                                "surname": !isEmpty(user) ? user.data.userDetails.lastName : "Lastname"
                                            },
                                            "email_address": !isEmpty(user) ? user.data.userDetails.email : "payer@example.com",
                                        }
                                    });
                                }}
                                onApprove={handlePaypalApprove}
                                onError={handlePaypalError}
                                onCancel={handlePaypalCancel}
                            />

                            {/* {success && <p style={{ color: "green" }}>Payment Successful!</p>}
                            {error && <p style={{ color: "red" }}>Error: {error}</p>} */}
                        </PayPalScriptProvider>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowUpdateTransactionModal(false) }}
                show={showUpdateTransactionModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static" keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Error
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-text">Something went wrong while processing payment confirmation. Please click try again to continue</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-yes-btn" onClick={() => { handleUpdateTransactionStatus() }}>TRY AGAIN</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default SubscriptionRenewScreen